/**
 * Header Component
 *
 * Top navigation bar with burger menu (ChatGPT style)
 */

import burgerIcon from "../assets/svg/burger.svg";
import { isPWA } from "../lib/platform";
import { Plus, Clock } from "lucide-react";
import { useLocation } from "react-router-dom";

interface HeaderProps {
  onMenuToggle: () => void;
  sidebarOpen: boolean;
  onNewChat?: () => void;
  onHistoryClick?: () => void;
}

export function Header({
  onMenuToggle,
  sidebarOpen,
  onNewChat,
  onHistoryClick,
}: HeaderProps) {
  const isInPWA = isPWA();
  const location = useLocation();
  const isChatRoute = location.pathname === "/chat";
  // Show burger on webapp always, on PWA only when sidebar is closed
  const showBurger = !isInPWA || !sidebarOpen;

  // Get chat handlers from window if not provided via props
  const handleNewChat =
    onNewChat || (window as any).chatHandlers?.handleNewChat;
  const handleHistoryClick =
    onHistoryClick || (window as any).chatHandlers?.handleHistoryClick;

  return (
    <header className="fixed top-0 left-0 right-0 h-14 bg-[#FAF6F1] dark:bg-[#1A2D47] border-b border-[#E5DDD3] dark:border-[#2C405F] z-40 flex items-center px-3 transition-all duration-300">
      {/* Left: Burger Menu */}
      {showBurger && (
        <button
          onClick={onMenuToggle}
          className="p-2 hover:bg-[#F5E9D7] rounded-lg transition-colors flex-shrink-0 mr-2"
        >
          <img src={burgerIcon} alt="Menu" className="w-5 h-5" />
        </button>
      )}

      {/* Logo and Title */}
      {/* <div className="flex items-center gap-2">
        <img src={logoImage} alt="DuneWorks" className="w-6 h-6" />
        <h1 className="text-[#1D1B19] font-semibold text-base">{pageTitle}</h1>
      </div> */}

      {/* Right: Action buttons for Chat route, empty for others */}
      <div className="ml-auto flex items-center gap-2">
        {isChatRoute && (
          <>
            <button
              type="button"
              onClick={handleNewChat}
              className="inline-flex items-center gap-2 rounded-lg bg-[#051c36] px-3 py-1.5 text-sm font-medium text-white shadow-md transition hover:bg-[#0c2a4e] hover:scale-[1.02]"
              disabled={!handleNewChat}
            >
              <Plus size={16} />
              New Chat
            </button>
            <button
              type="button"
              onClick={handleHistoryClick}
              className="inline-flex items-center gap-2 rounded-lg border border-[#E5DDD3] dark:border-[#455D7D] bg-white dark:bg-[#2C405F] px-3 py-1.5 text-sm font-medium text-[#1D1B19] dark:text-[#E3E6EA] shadow-sm transition hover:bg-[#FAF6F1] dark:hover:bg-[#455D7D] hover:scale-[1.02]"
              disabled={!handleHistoryClick}
            >
              <Clock size={16} />
              History
            </button>
          </>
        )}
      </div>
    </header>
  );
}
